import { ICallbackHandlers } from '../../models/field-config.interface';

export class LoginAttempt {
  config: ICallbackHandlers;
  constructor(config: ICallbackHandlers) {
    this.config = config;
  }
}
